import {
  FormField,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@folio/components/forms';
import type { Field } from 'korint-sdk/react';
import _ from 'lodash';
import { useFormContext } from 'react-hook-form';
import { FormBuilderField } from '../forms/form-builder/FormBuilderField';
import { Group } from '@folio/components/ui/flex';

const years = Array.from({ length: 50 }, (_, i) => new Date().getFullYear() - i);

const months = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];

const getDate = (year: string, month: string) => {
  if (!year || !month) return;
  return `${year}-${month.padStart(2, '0')}-01`;
};

export function VehicleCirculationDateFormField({ field }: { field: Field }) {
  const form = useFormContext();

  const date = form.watch(field.name) as string | undefined;
  const [year, month] = (date?.split('-') ?? []) as [string | undefined, string | undefined];

  return (
    <div>
      <FormField
        control={form.control}
        name={field.name}
        render={() => (
          <FormBuilderField field={field}>
            <Group align="stretch">
              <Select
                value={year}
                onValueChange={(y: string) => {
                  form.setValue('firstCirculationDate', getDate(y, month ?? '01'), {
                    shouldDirty: true,
                    shouldTouch: true,
                  });
                }}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Année" />
                </SelectTrigger>
                <SelectContent>
                  {years.map(y => (
                    <SelectItem key={y} value={y.toString()}>
                      {y}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <Select
                value={month}
                onValueChange={(m: string) => {
                  if (!year) return;
                  form.setValue('firstCirculationDate', getDate(year, m), {
                    shouldDirty: true,
                    shouldTouch: true,
                  });
                }}
                disabled={!year}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Mois" />
                </SelectTrigger>
                <SelectContent>
                  {months.map((label, index) => (
                    <SelectItem key={label} value={_.padStart((index + 1).toString(), 2, '0')}>
                      {label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </Group>
          </FormBuilderField>
        )}
      />
    </div>
  );
}
